import { cn } from '../../lib/cn'
import { TEXTOS } from '../../lib/glossario'
import type { DocumentoDoContrato } from '../../types/documentos'

const COR: Record<DocumentoDoContrato['leitura'], string> = {
  LIDO: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  SEM_TEXTO: 'bg-amber-50 text-amber-900 ring-amber-200',
  FALHOU: 'bg-red-50 text-red-800 ring-red-200',
}

/**
 * Se a consulta enxerga o documento — a pergunta que quem envia precisa ver respondida na hora.
 *
 * "Pronto" sozinho mentiria para o PDF meio escaneado: por isso a contagem de páginas lidas vem ao
 * lado, e a explicação aparece quando falta página. A cor nunca é o único sinal: o texto diz o estado.
 *
 * @param props o documento
 * @returns o selo e, quando preciso, a explicação
 */
export function SeloDaLeitura({ documento }: { documento: DocumentoDoContrato }) {
  const t = TEXTOS.documentos
  const comPaginas = documento.paginas !== undefined && documento.paginasComTexto !== undefined
  const faltaPagina = comPaginas && documento.leitura === 'LIDO' && documento.paginasComTexto! < documento.paginas!
  return (
    <div className="space-y-1.5">
      <p className="flex flex-wrap items-center gap-2 text-xs">
        <span className={cn('rounded-full px-2 py-0.5 font-medium ring-1 ring-inset', COR[documento.leitura])}>
          {t.leitura[documento.leitura]}
        </span>
        {comPaginas && documento.leitura === 'LIDO' && (
          <span className="text-slate-600">{t.paginasComTexto(documento.paginasComTexto!, documento.paginas!)}</span>
        )}
      </p>
      {documento.leitura === 'SEM_TEXTO' && <p className="max-w-prose text-xs text-amber-900">{t.semTextoAjuda}</p>}
      {documento.leitura === 'FALHOU' && documento.erroDeLeitura && (
        <p className="max-w-prose text-xs text-red-800">{documento.erroDeLeitura}</p>
      )}
      {faltaPagina && <p className="max-w-prose text-xs text-slate-600">{t.paginasFaltando}</p>}
    </div>
  )
}
